<template>
  <Loader v-if="loader" />
  <div class="card user-profile">
    <Toolbar class="p-mb-4">
    <template #start>
      <div class="p-d-flex p-ai-end w-full">
        <Button label="Nuovo utente" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />
        <div style="flex-grow: 1;"></div>
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
        </span>
      </div>
    </template>
    </Toolbar>
    <DataTable :value="items" editMode="row" dataKey="id" v-model:editingRows="editingRows" 
      @row-edit-save="onRowEditSave" :rowClass="rowClass" responsiveLayout="scroll"
      :paginator="true" :rows="20" :filters="filters" 
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 20, 50]" currentPageReportTemplate="{first} a {last} di {totalRecords}">
      <template #header>
        <div class="table-header p-d-flex p-jc-end">
          <!-- Search input positioned here if you want it to appear above the datatable and not in the toolbar -->
        </div>
      </template>
      <template #empty>
        <div class="text-center">Nessun dato trovato.</div>
      </template>

        <Column field="nome" header="Nome" style="width:30%">
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
            <template #body="{data}">
              <div v-if="currentUserSelfUser(data.id)">
                {{data.nome}} (io) <br>
                <small class="text-400">Modificando questo utente verrai disconesso e dovrai effettuare nuovamente il login</small>
              </div>
              <div v-else>
                {{data.nome}}
              </div>
            </template>
        </Column>
        <Column field="cognome" header="Cognome" style="width:20%">
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
        </Column>
        <Column field="email" header="Email" style="width:20%">
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" autofocus />
            </template>
        </Column>
        <Column field="new_profile" header="Profilo" style="width:20%">
            <template #editor="{ data, field }">
                <Dropdown v-model="data[field]" :options="profiles" optionLabel="name" optionValue="id" placeholder="Seleziona profilo">
                    <template #option="slotProps">
                        <span>{{slotProps.option.name}}</span>
                    </template>
                </Dropdown>
            </template>
            <template #body="slotProps">
                <div v-if="slotProps.data.profile.length > 0">
                  {{(slotProps.data.profile[0].name).toUpperCase()}}
                </div>
            </template>
        </Column>
        <Column :rowEditor="true" style="width:10%; min-width:8rem" bodyStyle="text-align:center"></Column>
        <Column :exportable="false">
            <template #body="{data}">
                <button @click="confirmDeleteUser(data)" class="p-row-editor-init p-link" type="button">
                  <span class="p-row-editor-init-icon pi pi-fw pi-trash"></span>
                </button>
            </template>
        </Column>
    </DataTable>
  </div>


  <!-- Dialog new user -->
  <Dialog v-model:visible="newUserDialog" :style="{width: '90%'}" header="Nuovo utente" :modal="true" class="p-fluid">
  <div class="grid" style="min-height:150px">
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Nome</label>
        <InputText  v-model.trim="newUser.nome" required="true" autofocus :class="{'p-invalid': validationErrors.nome && submitted}" :value="newUser.nome" />
        <small class="p-error" v-if="validationErrors.nome && submitted">Campo richiesto</small>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Cognome</label>
        <InputText  v-model.trim="newUser.cognome" required="true" autofocus :class="{'p-invalid': validationErrors.cognome && submitted}" :value="newUser.cognome" />
        <small class="p-error" v-if="validationErrors.cognome && submitted">Campo richiesto</small>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Email</label>
        <InputText  v-model.trim="newUser.email" required="true" autofocus :class="{'p-invalid': validationErrors.email || validationErrors.isEmail && submitted}" :value="newUser.email" />
        <small class="p-error" v-if="validationErrors.email && submitted">Campo richiesto</small>
        <small class="p-error" v-if="validationErrors.isEmail && submitted">Formato non valido</small>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Profilo</label>
        <Dropdown v-model="newUser.profile" :options="profiles" optionLabel="name" optionValue="id" placeholder="Seleziona profilo" :class="{'p-invalid': validationErrors.profile && submitted}" />
        <small class="p-error" v-if="validationErrors.profile">Campo richiesto</small>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <Checkbox v-model="isAvailableTicket" :binary="true" />
      <label class="ml-2"> Abilitato ai ticket </label>
    </div>
    <div class="col-12 md:col-3" v-if="isAvailableTicket">
      <div class="p-field">
        <label>Area Ticket</label>
        <Dropdown v-model="newUser.area_ticket" :options="typesAreaTicket" optionLabel="area" optionValue="id_ticket_area" placeholder="Seleziona area ticket" :class="{'p-invalid': validationErrors.profile && submitted}" />
        <small class="p-error" v-if="validationErrors.area_ticket">Campo richiesto</small>
      </div>
    </div>
  </div>
  <template #footer>
    <Button label="Annulla" icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2"  @click="newUserDialog = false" />
    <Button label="Salva" icon="pi pi-save"  class="p-button-rounded p-button-success" @click="saveNewUser" />
  </template>
</Dialog>


<!-- Dialog delete user -->
<Dialog v-model:visible="deleteUserDialog" :style="{width: '450px'}" header="Conferma eliminazione" :modal="true">
    <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="selectedUser">Confermi la cancellazione di {{selectedUser.email}}</span>
    </div>
    <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteUserDialog = false"/>
        <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteSelectedUser" />
    </template>
</Dialog>

    
</template>

<script>
import AuthService from '../services/auth/auth.service';
import { FilterMatchMode } from 'primevue/api';
import { useStore } from 'vuex'
import {useRouter} from 'vue-router';
import Service from '@/services/ask-pratiche/pratiche-service'
import TicketService from '@/services/ask-ticket/ticket-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
    components: {
      Loader
    },
     setup() {
        const store = useStore()
        const toast = useToast();
        const router = useRouter()  
        const loader = ref(false);
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const service = new Service(self.$http, self.$eventBus)
        const ticketservice = new TicketService(self.$http, self.$eventBus)
        const currentUser = JSON.parse(atob(store.state.auth.user)).user[0]
        const submitted = ref(false);
        const validationErrors = ref({})
        const items = ref([]);
        const profiles = ref([]);
        const typesAreaTicket = ref([]);
        const isAvailableTicket = ref(false)
        const selectedUser = ref();
        const editingRows = ref([]);
        const newUser = ref({});
        const newUserDialog = ref(false);
        const deleteUserDialog = ref(false);

        onMounted(() => {
          getProfiles()      
          getTypesAreaTicket()      
          getData() 
        })

        const getProfiles = () => {
          service.getProfiles().then((res) => {
            profiles.value = res.items
          })
        }

        const getTypesAreaTicket = () => {
          ticketservice.getTypesAreaTicket().then((res) => {
            typesAreaTicket.value = res.items
          })
        }

        const getData = () => {
          loader.value = true;
          service.getUsersWithProfiles().then((res) => {
            if (res.items.length > 0) {
              res.items.forEach(el => {
                el.new_profile = el.profile.length > 0 ? el.profile[0].id : 0
              });
              items.value = res.items
            }
          }).finally(() => {
              loader.value = false;
          })
        }

        const onRowEditSave = (event) => {
          loader.value = true;
          let { newData, index } = event;
          let newProfileObj = profiles.value.filter(el => el.id == newData.new_profile)
          newData.profile = newProfileObj
          service.editUserProfile(newData).then((res) => {
            if (res) {
              items.value[index] = newData;
              if (currentUserSelfUser(newData.id)) {
                disconnect()
              }
            }
          }).finally(() => {
              loader.value = false;
          })
        };

        const openNew = () => {
          newUser.value = {}
          submitted.value = false;
          newUserDialog.value = true;
        };
        const saveNewUser = () => {
          submitted.value = true;
          if (validateForm()) {
            loader.value = true;
            service.createUser(newUser.value).then((res) => {
              if (res.item.success) {
                toast.add({severity:'success', summary: 'Successo', detail:res.item.msg});
                getData()
              } else {
                toast.add({severity:'warn', summary: 'Attenzione', detail:res.item.msg});
              }
            }).finally(() => {
              newUserDialog.value = false;
              loader.value = false;
            })
          }         
        };

        const confirmDeleteUser= (user) => {
          selectedUser.value = user
          deleteUserDialog.value = true;
        };

        const deleteSelectedUser = () => {
          loader.value = true;
          service.deleteUser(selectedUser.value).then((res) => {
            if (res) {
              if (currentUserSelfUser(selectedUser.value.id)) {
                disconnect()
              } else {
                getData()
              }
            }
          }).finally(() => {
            deleteUserDialog.value = false;
            loader.value = false;
          })
        }

        const rowClass = (data) => {
            return currentUserSelfUser(data.id) ? 'row-self-users' : null
        };

        const currentUserSelfUser = (id_data) => {
            return currentUser.id == id_data
        };

        const disconnect = () => {
          AuthService.logout();
          router.push("/login");
        }

        const validateForm = () => {
          let regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

          if (newUser.value.nome && newUser.value.nome != '')
            delete validationErrors.value['nome'];
          else
            validationErrors.value['nome'] = true;

          if (newUser.value.cognome && newUser.value.cognome != '')
            delete validationErrors.value['cognome'];
          else
            validationErrors.value['cognome'] = true;

          if (newUser.value.email && newUser.value.email != '') {
            delete validationErrors.value['email'];
            if (regex_email.test(newUser.value.email)) {
              delete validationErrors.value['isEmail'];
            } else {
              validationErrors.value['isEmail'] = true;
            }
          } else {
            validationErrors.value['email'] = true;
          }
            
          if (newUser.value.profile)
            delete validationErrors.value['profile'];
          else
            validationErrors.value['profile'] = true;

          if (isAvailableTicket.value) {
            if (newUser.value.area_ticket)
              delete validationErrors.value['area_ticket'];
            else
              validationErrors.value['area_ticket'] = true;
          } else {
            delete validationErrors.value['area_ticket'];
          }
              
          return !Object.keys(validationErrors.value).length;
        }

        
        return { 
          items,
          currentUser,
          loader,
          submitted,
          validationErrors,
          filters,
          editingRows,
          onRowEditSave,
          profiles,
          typesAreaTicket,
          isAvailableTicket,
          newUser,
          newUserDialog,
          openNew,
          saveNewUser,
          rowClass,
          currentUserSelfUser,
          confirmDeleteUser,
          selectedUser,
          deleteUserDialog,
          deleteSelectedUser,
          validateForm
         }
    }
}
</script>
<style>
.user-profile .p-row-editor-init:hover  .pi-pencil{
   color: #2196f3 !important;
}
.user-profile .p-row-editor-init:hover  .pi-trash{
   color: #f93d3d !important;
}
</style>
<style scoped>
::v-deep(.row-self-users) {
    background-color: rgba(98, 172, 251, 0.15) !important;
}
</style>
